
import { TableConfig, DataTable } from "@app/interfaces";

export class BrokerAdminTableConfig implements DataTable {

    constructor() { }

    static configure(): TableConfig {

        const tableConfig: TableConfig = {
            key: 'items',
            searchPanel: true,
            groupPanel: false,
            showPagination: {
                showPageSizeSelector: true,
                pageSize: 10,
                allowedPageSizes: [10, 25, 50, 100]
            },
            fields: [
                {
                    caption: 'Name',
                    dataField: 'name'
                },
                {
                    caption: 'Email',
                    dataField: 'user.email'
                },
                {
                    caption: 'Business',
                    dataField: 'business'
                },
                {
                    caption: 'Action',
                    width: 80,
                    cellTemplate: {
                        id: 'itemsActionButtons',
                        buttons: [{
                            icon: 'fa-solid fa-arrow-right',
                            name: "Edit",
                            eventName: "edit"
                        }],
                    },
                },
            ]
        };

        return tableConfig;

    }

}